import apiClient from './_client';

export default {
    login(email, password) {
        return apiClient.post('login', {
            email,
            password
        });
    },
    logout() {
        return apiClient.post('logout', {});
    },
    register(payload) {
        return apiClient.post('register', payload);
    },
}
